import { useState, useEffect } from 'react';

function usePublic(path = '/content/projects/projectsConfig.json') {
    const [data, setData] = useState([]);
    const url = `${process.env.PUBLIC_URL}${path}`;

    useEffect(() => {
        fetch(url)
            .then(response => response.json())
            .then(json => setData(json))
            .catch(() => setData([]));
    }, [url]);

    return data;
}

export default usePublic;
